import { getValueReduxUtil } from '../get-value'
import { MODEL_KEY } from '../../../model/constants'
import { getObjectUtil } from 'packages/src'

function getCreatedAtReduxUtil (instance) {
  return (
    getValueReduxUtil(instance, MODEL_KEY.CREATED_AT) ||
    getObjectUtil(instance, MODEL_KEY.CREATED_AT)
  )
}

export default getCreatedAtReduxUtil
